/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CUSTOMER_DATA_PLATFORM } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';
import { getSegmentPath } from '../Utilities/GetSegmentPath/GetSegmentPath';

/**
 * The paths for each screen.
 */
export const screenPaths = {
  dashboard: `${CUSTOMER_DATA_PLATFORM.path}`,
  eventBuilder: `${CUSTOMER_DATA_PLATFORM.path}/event/create-web-behavior`,
  eventBuilderUpdate: `${CUSTOMER_DATA_PLATFORM.path}/event/:eventId`,
  events: `${CUSTOMER_DATA_PLATFORM.path}/events`,
  scvCustomerProfile: `${CUSTOMER_DATA_PLATFORM.path}/customers/:customerId`,
  scvCustomers: `${CUSTOMER_DATA_PLATFORM.path}/customers`,
  scvExports: `${CUSTOMER_DATA_PLATFORM.path}/exports`,
  segmentation: `${CUSTOMER_DATA_PLATFORM.path}/segmentation`,
  segmentationConfig: `${CUSTOMER_DATA_PLATFORM.path}/segmentation/config`,
  segmentBuilderCreate: `${CUSTOMER_DATA_PLATFORM.path}/segmentation/create`,
  segmentBuilderUpdate: `${CUSTOMER_DATA_PLATFORM.path}/segmentation${getSegmentPath(`/`)}`,
  segmentInsights: `${CUSTOMER_DATA_PLATFORM.path}/segment-insights`,
};
